<template>
  <b-sidebar
    :visible="visible"
    right
    shadow
    width="480px"
    backdrop
    title="Detalle del ticket"
    @change="onChange"
  >
    <div class="px-3 py-2">
      <div v-if="loading" class="text-center my-4"><b-spinner></b-spinner></div>
      <div v-else-if="!detail">
        <p class="text-muted">Selecciona un ticket.</p>
      </div>
      <div v-else>
        <b-card class="mb-2" body-class="py-2">
          <div class="d-flex justify-content-between">
            <div>
              <div class="font-weight-bold">Ticket #{{ ticket.ticket_id }}</div>
              <div class="small text-muted">Sucursal {{ ticket.sucursal_id }} · {{ ticket.channel_label }}</div>
              <div class="small text-muted">{{ ticket.date_close }}</div>
            </div>
            <div class="text-right">
              <div class="h5 mb-0">{{ money(ticket.total_with_discount) }}</div>
              <div class="small text-muted">Propina {{ money(ticket.tip) }}</div>
            </div>
          </div>
        </b-card>

        <h6>Productos</h6>
        <b-table small striped :items="detail.lines || []" :fields="lineFields" show-empty
          empty-text="Sin líneas.">
          <template #cell(total_with_discount)="d">{{ money(d.item.total_with_discount) }}</template>
          <template #cell(price)="d">{{ money(d.item.price) }}</template>
        </b-table>

        <h6 class="mt-3">Pagos</h6>
        <b-table small striped :items="detail.payments || []" :fields="payFields" show-empty
          empty-text="Sin pagos.">
          <template #cell(payment_amount)="d">{{ money(d.item.payment_amount) }}</template>
        </b-table>

        <h6 class="mt-3">Puntos (ledger)</h6>
        <b-table small striped :items="detail.ledger || []" :fields="ledgerFields" show-empty
          empty-text="Sin movimientos de puntos."></b-table>

        <h6 class="mt-3">Entrega</h6>
        <b-table small striped :items="detail.delivery || []" :fields="deliveryFields" show-empty
          empty-text="Sin eventos de entrega."></b-table>

        <b-alert show variant="light" class="small mt-2">
          Encuestas del ticket: <strong>Fase 5 diferida</strong>.
        </b-alert>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import executiveService from '@/services/executiveService';

// Detalle completo de un ticket/folio (doc 04 §3). survey_responses se omite: Fase 5.
export default {
  name: 'TicketDrawer',
  props: {
    visible: { type: Boolean, default: false },
    sucursalId: { type: [Number, String], default: null },
    ticketId: { type: [Number, String], default: null }
  },
  data() {
    return {
      loading: false,
      detail: null,
      lineFields: [
        { key: 'product_code', label: 'Código' },
        { key: 'quantity', label: 'Cant.' },
        { key: 'price', label: 'Precio' },
        { key: 'total_with_discount', label: 'Total' }
      ],
      payFields: [
        { key: 'payment_method_id', label: 'Método' },
        { key: 'payment_amount', label: 'Monto' },
        { key: 'status', label: 'Estatus' }
      ],
      ledgerFields: [
        { key: 'entry_type', label: 'Tipo' },
        { key: 'points', label: 'Puntos' },
        { key: 'reason', label: 'Motivo' },
        { key: 'created_at', label: 'Fecha' }
      ],
      deliveryFields: [
        { key: 'status', label: 'Estatus' },
        { key: 'created_at', label: 'Fecha' }
      ]
    };
  },
  computed: {
    ticket() {
      return (this.detail && this.detail.ticket) || {};
    }
  },
  watch: {
    ticketId(v) {
      if (v && this.visible) this.load();
    },
    visible(v) {
      if (v && this.ticketId) this.load();
    }
  },
  methods: {
    money(v) {
      const n = Number(v || 0);
      return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    onChange(val) {
      if (!val) this.$emit('close');
    },
    load() {
      if (!this.sucursalId || !this.ticketId) return;
      this.loading = true;
      executiveService.ticketDetail(this.sucursalId, this.ticketId)
        .then((res) => { this.detail = res.data || null; })
        .catch(() => { this.detail = null; })
        .finally(() => { this.loading = false; });
    }
  }
}
</script>
